import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import BookingCalendar from '../components/BookingCalendar'; // <-- import nouveau composant
import './MyProfile.css';

export default function MyProfile() {
  const [musician, setMusician] = useState(null);

  useEffect(() => {
    const fetchMyProfile = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const q = query(collection(db, 'Musiciens'), where('userId', '==', user.uid));
      const snapshot = await getDocs(q);
      if (!snapshot.empty) {
        setMusician({ id: snapshot.docs[0].id, ...snapshot.docs[0].data() });
      }
    };

    fetchMyProfile();
  }, []);

  if (!musician) return <p style={{ color: 'white', textAlign: 'center' }}>Chargement du profil...</p>;

  return (
    <div className="musician-profile-container animated-fade-in">
      <h1>Mon Profil</h1>
      <div className="musician-profile-info">
        <p><strong>Nom :</strong> {musician.name}</p>
        <p><strong>Ville :</strong> {musician.city}</p>
        <p>
          <strong>Genre{(musician.genres?.length || 0) > 1 ? 's' : ''} :</strong> {
            musician.genres?.join(', ') || 'Non spécifié'
          }
        </p>
        <p><strong>Type :</strong> {musician.type}</p>
        <p><strong>Bio :</strong> {musician.bio}</p>
        <p><strong>Vidéo YouTube :</strong> {musician.youtubeVideo}</p>
      </div>

      <h2>Mes réservations</h2>
      <div className="musician-profile-bookings">
        <BookingCalendar musicianId={musician.id} />
      </div>
    </div>
  );
}
